module.exports = __webpack_public_path__ + "img/Unity_Certified_User_Certificate.cb9f1271.png";